import { UtilsProvider } from '../providers/myria/utils-provider';
import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { ResourceProvider } from '../providers/resource/resource';

@Pipe({
  name: 'country'
})
@Injectable()
export class CountryPipe implements PipeTransform {
  constructor(
    public resourceProvider: ResourceProvider
  ) {}

  transform(value, args) {
    return this.resourceProvider.getCountryByNameAbbrev(value).then(country => (country ? country.Name : value), x => value);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/country-pipe.ts